import Builder, {
  DefaultOptions as DF,
  BuilderProps as Props,
} from "./Builder";
export const DefaultOptions = DF;
export type BuilderProps = Props;
export default Builder;
